<template>
  <Layout>
    <div class="__Header">
      <Header
        @toggleMenu="onToggleMenu"
        :logoUrl="logoUrl"
        :logoWidth="120"
        logo-alt="Wave PRO logo"
        @click-logo="goToHome"
      >
        <template v-slot:header-right>
          <Separator vertical />
          <UserMenu />
        </template>
      </Header>

      <div class="__Header-LogoSub">
        <Chip label="PRO" color="primary" size="14px" class="glossy chip" square />
      </div>

      <div class="__Header-LogoEnv" v-if="currentEnv === 'next'">NEXT {{ appVersion }}</div>
    </div>

    <Sidebar :mini="mini" />

    <DevTool v-model="devTool" v-if="visibleDevTools" />

    <q-page-container>
      <q-page>
        <router-view name="contents" />
      </q-page>
    </q-page-container>
  </Layout>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import moment from 'moment';
import Cookies from 'js-cookie';
import Config from '@/config';
import Layout from '@design-system/layouts/Layout.vue';
import Header from '@design-system/layouts/Header.vue';
import PageContainer from '@design-system/layouts/PageContainer.vue';
import Separator from '@design-system/components/Separator.vue';
import Icon from '@design-system/components/Icon.vue';
import Selector from '@design-system/components/Selector.vue';
import Chip from '@design-system/components/Chip.vue';

import Sidebar from '@/layouts/Sidebar';
import DevTool from '@/layouts/DevTool';
import UserMenu from '@/layouts/Header/HeaderItems/OwnerMenu';

export default {
  name: 'DefaultLayout',
  components: {
    Layout,
    Header,
    Sidebar,
    DevTool,
    PageContainer,
    Separator,
    UserMenu,
    Icon,
    Selector,
    Chip,
  },
  data() {
    return {
      imgUrl: null,
      logoUrl: require(`../assets/img/wave-logo.svg`),
      mini: false,
      devTool: true,
    };
  },
  created() {
    const lang = this.$store.state.userState.settings.language;
    this.$i18n.locale = lang;
    this.$validator.localize(lang);
    moment.locale(lang);

    // Toggle menu
    const sideMenuState = Cookies.get('side-menu-close', { path: Config.cookiePath });
    this.mini = sideMenuState ? JSON.parse(sideMenuState) : false;

    // Dev Tools
    const isVisible = Cookies.get('wave-devtools-visible');
    if (isVisible !== undefined) {
      this.updateIsVisible(JSON.parse(isVisible));
    }
  },
  mounted() {
    this.getImage()
      .then(res => {
        this.imgUrl = res;
      })
      .catch(() => {
        this.imgUrl = null;
      });
  },
  computed: {
    ...mapState('user', {
      mspId: state => state.data.msp_id,
    }),

    ...mapState('status', {
      status: state => state.status,
    }),

    ...mapGetters('status', {
      currentStatus: 'currentStatus',
    }),

    ...mapState('devTools', {
      visibleDevTools: state => state.isVisible,
    }),

    currentEnv() {
      return process.env.VUE_APP_MODE;
    },

    appVersion() {
      return Config.version;
    },

    showImg() {
      return !!this.imgUrl;
    },

    showAlert() {
      if (!this.status['message']) return false;

      if (this.status['msp_id']) {
        return this.status['msp_id'] === this.mspId;
      } else {
        return true;
      }
    },
  },
  methods: {
    ...mapMutations('devTools', ['updateIsVisible']),

    onToggleMenu() {
      const state = !this.mini;
      Cookies.set('side-menu-close', JSON.stringify(state), { path: Config.cookiePath });

      this.mini = state;
    },

    getImage() {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = `https://ripple-user.s3-ap-northeast-1.amazonaws.com/logo/${this.mspId}/logo_vertical.png`;

        img.onload = function() {
          return resolve(img.src);
        };

        img.onerror = function() {
          return reject();
        };
      });
    },

    goToHome() {
      this.$router.push('/dashboard').catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.__Header {
  position: relative;

  &-LogoSub {
    position: fixed;
    top: 7px;
    left: 190px;
    z-index: 4000;
    font-size: 1.75rem;
    display: flex;
    align-items: center;
    font-weight: 800;

    .chip::v-deep {
      transform: skewX(-20deg);
      margin-right: 10px;
    .ellipsis {
      transform: skewX(20deg);
      }
    }
  }

  &-LogoEnv {
    position: fixed;
    top: 45px;
    left: 145px;
    z-index: 4000;
    font-size: 12px;
    line-height: 1;
    font-weight: 700;
  }
}

.collaborator {
  text-align: right;

  span {
    margin-right: 0.5rem;
    font-size: 0.6em;
    color: $secondary;
  }

  .logo {
    height: 7px;
  }
}

@media (min-width: $sm) {
  .collaborator {
    position: relative;
    top: -15px;
    .logo {
      height: 10px;
    }
  }
}
</style>
